import React from "react";
import { IconButton, Link } from "@mui/material";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import "./../../styles/SidePanel.css";
const TopPanel = () => {
  return (
    <div className="sidenav">
      <Link href="/search" underline="none" >
      <IconButton
        className="sidebar-button"
      >
        <NavigateBeforeIcon htmlColor="#fff"/> <span>Back to Search</span>
      </IconButton>
      </Link>
    </div>
  );
}

export default TopPanel;
